import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    width: '100%',
    minWidth: 0,
    backgroundColor: '#f5f5f5',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',
  },
  pageMessage: {
    marginBottom: '12px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '38px',
    ...shorthands.gap('6px'),
    ...shorthands.padding('0', '2px', '8px'),
    ...shorthands.borderBottom('2px', 'solid', '#0f6cbd'),
    backgroundColor: 'transparent',
    flexShrink: 0,
    '@media (max-width: 700px)': {
      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
  },
  backButton: {
    minWidth: 0,
    minHeight: '24px',
    height: '24px',
    ...shorthands.padding('0', '4px'),
    fontSize: '11px',
  },
  title: {
    color: tokens.colorNeutralForeground1,
    fontSize: '21px',
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: '28px',
    '@media (max-width: 700px)': {
      width: '100%',
    },
  },
  headerActions: {
    marginLeft: 'auto',
    '@media (max-width: 700px)': {
      marginLeft: 0,
      width: '100%',
    },
  },
  deleteButton: {
    color: '#c50f1f',
    minHeight: '24px',
    height: '24px',
    fontSize: '11px',
  },
  content: {
    flex: 1,
    minHeight: 0,
    ...shorthands.padding('14px', '0', '0'),
    '@media (max-width: 700px)': {
      ...shorthands.padding('10px', '0', '0'),
    },
  },
  inner: {
    width: '100%',
    maxWidth: 'none',
  },
  formCard: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    ...shorthands.gap('12px'),
    ...shorthands.padding('16px'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.borderRadius('4px'),
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
    '@media (max-width: 700px)': {
      ...shorthands.padding('12px'),
    },
  },
  cardHeading: {
    fontSize: '14px',
    fontWeight: tokens.fontWeightSemibold,
  },
  cardDescription: {
    color: tokens.colorNeutralForeground3,
    fontSize: '11px',
    lineHeight: '16px',
  },
  updatedAt: {
    color: tokens.colorNeutralForeground3,
    fontSize: '11px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    ...shorthands.gap('8px'),
    ...shorthands.padding('4px', '0', '0'),
    '& button': {
      minHeight: '26px',
      height: '26px',
      fontSize: '11px',
    },
  },
  stateCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    ...shorthands.gap('16px'),
    ...shorthands.padding('24px'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.borderRadius('4px'),
  },
  stateText: {
    color: tokens.colorNeutralForeground2,
  },
});